<div class="row form">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="page-title-box form__head">
        <div class="row align-items-center">
          <div class="col-sm-6 col-6">
            <a class="page-title form__head__title" (click)="cancel()">
              <i class="fas fa-arrow-left m-r-5"></i>Salidas por transporte
            </a>
          </div>
          <div class="col-sm-6 col-6 form__head__boxBtn">
            <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="card m-b-30">
        <div class="card-body">
          <div class="row">
            <div class="form-group col-lg-6">
              <label>Transporte
                <span class="required"></span>
              </label>
              <ng-container *ngIf="transportSelected != null">
                <div class="input-group">
                  <input type="text" class="form-control form-control-sm" disabled value="{{transportSelected.owner}}-{{transportSelected.vehicle_type}}">
                  <div class="input-group-append bg-custom b-0 removeClient">
                    <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                      (click)="removeGuide()">
                      <i class="fas fa-backspace w-100 f-s-12"></i>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="transportSelected == null">
                <component-search-transport [classSize]="'search-small'" (selectedTransportEvent)="selectedTransportSearch($event)"
                  class="w-100">
                </component-search-transport>
              </ng-container>
            </div>
          </div>
          <app-loading-modal></app-loading-modal>
          <div class="row m-t-15">
            <ng-container *ngIf="transportSelected == null">
              <div class="col-lg-12">
                <p class="f-s-14 text-center">Seleccionar opción para cargar vista <i class="fas fa-table m-l-5"></i></p>
              </div>
            </ng-container>
            <ng-container *ngIf="transportSelected != null">
              <div class="col-lg-12">
                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link pointer" [class.active]="activeTab === 'home'" (click)="setActiveTab('home')"
                      role="tab">
                      <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
                      <span class="d-none d-sm-block">Resumen general</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link pointer" [class.active]="activeTab === 'list_calendar'"
                      (click)="setActiveTab('list_calendar')" role="tab">
                      <span class="d-block d-sm-none"><i class="far fa-list"></i></span>
                      <span class="d-none d-sm-block">Calendario salidas</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link pointer" [class.active]="activeTab === 'list_group'"
                      (click)="setActiveTab('list_group')" role="tab">
                      <span class="d-block d-sm-none"><i class="far fa-list"></i></span>
                      <span class="d-none d-sm-block">Lista de grupos</span>
                    </a>
                  </li>                  
                </ul>
                <div class="tab-content p-t-15 text-muted">
                  <div class="tab-pane" [class.active]="activeTab === 'home'" role="tabpanel">
                    <div class="col-12">
                      <div class="row justify-content-md-center">
                        <div class="col-lg-12">
                          <label class="text-center bold text-dark f-s-15">Se muestran los datos acorde a fechas seleccionadas</label>
                          <div class="content__subhead__inputGrid m-r-5">
                            <div class="input-group" style="width: auto;">
                              <span class="input-group-prepend">
                                <span class="input-group-text content__subhead__inputGrid__title">
                                  <i class="far fa-calendar-alt m-r-5"></i> Seleccionar fecha
                                </span>
                              </span>
                              <input type="text" id="date_range_projection"
                                class="form-control content__subhead__inputGrid__input">
                            </div>
                          </div>
                        </div>
                        <div class="col-12 m-t-25">
                          <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions"
                            (chartInstance)="onChartInstance($event)" style="width: 100%; height: 400px; display: block;">
                          </highcharts-chart>
                        </div>
                      </div>
                      <div class="row m-t-30">
                        <div class="col-lg-6" id="summaryGuideByTour">
                          <p class="m-b-10 text-dark f-s-14">
                            <span class="bold">Lista resumen salidas por cada Tour</span>                          
                            <span *ngIf="!is_all" class="m-l-10">({{start_range | date: 'mediumDate'}} - {{end_range | date: 'mediumDate'}})</span>
                            
                            <button class="btn btn-default float-right" (click)="printerSummaryGuideByTour()">
                              <i class="fas fa-print f-s-14"></i>
                            </button>
                          </p>
                          <div class="table-responsive">
                            <table class="table table-bordered">
                              <thead class="thead-default">
                                <tr>
                                  <th>Nombre Tour</th>
                                  <th class="text-center">N° Grupos</th>
                                  <th class="text-center">N° PAX</th>
                                </tr>
                              </thead>
                              <tbody>
                                <ng-container *ngFor="let item of items">
                                  <tr>
                                    <td>{{item.description}}</td>
                                    <td class="text-center">{{item.quantity_groups}}</td>
                                    <td class="text-center">{{item.quantity_pax}}</td>
                                  </tr>
                                </ng-container>
                              </tbody>
                              <tfoot>
                                <tr>
                                  <th class="text-center">RESUMEN TOTALES</th>
                                  <th class="text-center">{{total_groups}}</th>
                                  <th class="text-center">{{total_pax}}</th>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                        <div class="col-lg-6" id="summaryGuideByTransport">
                          <p class="m-b-10 text-dark f-s-14">
                            <span class="bold">Resumen salidas por Guia asignado</span>                          
                            <span *ngIf="!is_all" class="m-l-10">({{start_range | date: 'mediumDate'}} - {{end_range | date: 'mediumDate'}})</span>
                            
                            <button class="btn btn-default float-right" (click)="printerSummaryGuideByTransport()">
                              <i class="fas fa-print f-s-14"></i>
                            </button>
                          </p>
                          <div class="table-responsive">
                            <table class="table table-bordered">
                              <thead class="thead-default">
                                <tr>
                                  <th>Guias de viaje</th>
                                  <th class="text-center">N° Grupos</th>
                                </tr>
                              </thead>
                              <tbody>
                                <ng-container *ngFor="let item of items_transport">
                                  <tr>
                                    <td>{{item.description}}</td>
                                    <td class="text-center">{{item.quantity_groups}}</td>
                                  </tr>
                                </ng-container>
                              </tbody>
                              <tfoot>
                                <tr>
                                  <th class="text-center">RESUMEN TOTALES</th>
                                  <th class="text-center">{{total_groups}}</th>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane" [class.active]="activeTab === 'list_calendar'" role="tabpanel">
                    <div class="row m-t-10">
                      <div class="col-lg-12">
                        <div class="row">
                          <div class="col-lg-4 col-12">
                            <div class="content__subhead__inputGrid m-r-5">
                              <div class="input-group" style="width: auto;">
                                <span class="input-group-prepend">
                                  <span class="input-group-text content__subhead__inputGrid__title">
                                    <i class="far fa-calendar-alt m-r-5"></i> Seleccionar Mes
                                  </span>
                                </span>
                                <input type="text" id="date_calendar"
                                  class="form-control content__subhead__inputGrid__input" readonly>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6 col-12">
                            <div class="table responsive">
                              <table>
                                <thead>
                                  <tr>
                                    <th>N° TOTAL DE SALIDAS</th>
                                    <th class="text-center">{{data_calendar.length}} grupos asignados</th>
                                  </tr>
                                </thead>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-12 m-t-25">
                        <highcharts-chart [Highcharts]="HighchartsHeatmap" [options]="chartOptionsHeatmap"
                          [(update)]="updateFlagHeatmap" (chartInstance)="chartHeatmap = $event"
                          style="width: 100%; height: 500px; display: block"></highcharts-chart>
                      </div>
                      
                    </div>
                  </div>
                  <div class="tab-pane" [class.active]="activeTab === 'list_group'" role="tabpanel">
                    <div class="row">
                      <div class="col-12 m-b-15 m-t-10">
                        <div class="row">
                          <div class="col-lg-4">
                            <div class="content__subhead__inputGrid">
                              <div class="input-group">
                                <span class="input-group-prepend">
                                  <span class="input-group-text content__subhead__inputGrid__title">
                                    Total
                                  </span>
                                </span>
                                <input type="text" class="form-control content__subhead__inputGrid__input text-center"
                                  value="{{dataPagination.totalItems}}" style="width: 50px !important;" disabled>
                              </div>
                            </div>
                            <!-- <a class="btn btn-outline-danger btn-sm f-s-10" target="_blank"
                              href="/{{branchofficeSlug}}/api/export/schedule/summary_list_group?guide_id={{transportSelected.id}}&export_pdf=true/"><i
                                class="far fa-file-pdf m-r-3"></i>Exportar PDF</a> -->
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="table-responsive">
                          <table class="table table-hover mb-0">
                            <thead class="thead-default">
                              <tr>
                                <th>Código/Fecha</th>
                                <th>Fecha</th>
                                <th>Tour/destino</th>
                                <th>Transporte</th>
                                <th>Guia</th>
                                <th class="text-center">N° Pax</th>
                                <th class="text-center">Acciones</th>
                              </tr>
                            </thead>
                            <tbody>
                              <ng-container *ngIf="items_group.length == 0">
                                <td colspan="2"><span>No se encontraron registros</span></td>
                              </ng-container>
                              <ng-container *ngIf="items_group.length > 0">
                                <tr
                                  *ngFor="let item of items_group | paginate: { itemsPerPage: dataPagination.pageSize, currentPage: dataPagination.currentPage, totalItems:dataPagination.totalItems }; let i = index">
                                  <td class="nowrap">
                                    <span class="bold f-s-12">{{item.code}}</span>
                                  </td>
                                  <td>
                                    {{item.date_departure | date: 'mediumDate'}}
                                  </td>
                                  <td>{{item.tour_data.description}}</td>
                                  <td>{{item.transport_data.owner}}</td>
                                  <td>{{item.guide_data.fullname}}</td>
                                  <td class="text-center">{{item.capacity_selected}}</td>
                                  <td class="text-center nowrap">
                                    <a href="/{{branchofficeSlug}}/api/groups/list/export/{{item.date_departure}}/{{item.tour_id}}"
                                      class="btn btn-small btn-default f-s-15 m-r-5" target="_blank"
                                      style="padding: 1px 5px;"><i class="far fa-file-pdf text-danger"></i>
                                    </a>
                                  </td>
                                </tr>
                              </ng-container>
                            </tbody>
                          </table>
                        </div>
                        <div class="col-md-12 ">
                          <div class="row content_pagination">
                            <div class="col-lg-4">
                              <p class="pagination__label">Total <span class="bold">{{dataPagination.totalItems}}</span>
                                registros.
                              </p>
                            </div>
                            <div class="text-right col-lg-8">
                              <ng-container *ngIf="items.length > 0">
                                <app-pagination (paginateEvent)="handlePageChange($event)"></app-pagination>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  